export const RANGE_CHIPS = [
  { value: 'YTD', label: 'YTD', note: 'year to date' },
  { value: 'QTD', label: 'QTD', note: 'quarter to date' },
  { value: 'MTD', label: 'MTD', note: 'month to date' },
];

/**
 * Map the design's YTD / QTD / MTD chips onto the metrics API named ranges.
 * The API picks the chart grain from this: months vs last year, weeks vs last
 * quarter, days vs last month.
 */
export function toMetricRangeParams(rangeType) {
  if (rangeType === 'QTD' || rangeType === 'MTD') {
    return { rangeType };
  }
  return { rangeType: 'YTD' };
}

export function rangeNote(rangeType) {
  return RANGE_CHIPS.find((chip) => chip.value === rangeType)?.note || 'year to date';
}
